module.exports = __webpack_public_path__ + "static/media/a1.bf4562e1.jpg";